// 工单类型
export enum WorkorderType {
    '客户投诉' = 1,
    '客户咨询',
    '门店咨询',
    '其它',
}

// 工单紧急程序
export enum WorkorderLevel {
    '紧急' = 1,
    '正常',
}

// 工单状态
export enum WorkorderStatus {
    '待处理',
    '处理中',
    '已处理',
    '已完结',
    '已超时',
}

// 工单申请状态
export enum WorkorderApplyStatus {
    '未申请',
    '已申请',
    '申请通过',
    '申请驳回',
}